import { Injectable, Type } from '@angular/core';
import {
  ApiResponse,
  BaseApiService,
} from '@kinet-open-network/client/core/api-client';
import { IGeneralOptionsTasks } from '@kinet-open-network/shared/data-access/model';
import { map } from 'rxjs';
import { Task } from '../models/task.model';

@Injectable({
  providedIn: 'root',
})
export class TasksService extends BaseApiService<Task> {
  override model: Type<Task> = Task;

  override get endpoint(): string {
    return '/tasks';
  }

  getTasksOptions() {
    return this.http
      .get<ApiResponse<IGeneralOptionsTasks>>(`/general-options/tasks`)
      .pipe(map((data) => data.data));
  }
}
